import { useRef } from 'react';
import { Swiper as SwiperType, Navigation, Pagination } from 'swiper';
import { SwiperSlide, Swiper } from 'swiper/react';

import { useAppSelector } from '../../store';
import { AscHeading, AscSkillProgressCard } from '@ascendnow/ascend-components';
import { PLATFORM_ROUTES } from '@platform/constants';
import styles from '@platform/styles/pages/home.module.scss';

export const AscDashboardSkillProgress = () => {
    const { skillProgress } = useAppSelector((state) => state.dashboard.dashboard);
    const swiperRef = useRef<SwiperType>();
    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <AscHeading level={5}>Performance</AscHeading>
            </div>
            {skillProgress && skillProgress?.statsPerCategories && skillProgress?.statsPerCategories?.length > 0 && (
                <Swiper
                    slidesPerView="auto"
                    spaceBetween={20}
                    pagination={{ clickable: true }}
                    modules={[Navigation, Pagination]}
                    onBeforeInit={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    className={styles.skillProgressCardList}
                >
                    {skillProgress?.statsPerCategories.map((skill, index) => (
                        <SwiperSlide key={skill.categoryId} style={{ width: 'fit-content' }}>
                            <AscSkillProgressCard
                                skillTitle={skill.name}
                                badgeColor={skill.badgeColor}
                                numberOfModules={skill.totalModules}
                                totalModules={skill.totalModules}
                                completedModules={skill.overallCompletedModules}
                                totalChallenges={skill.overallChallenges}
                                completedChallenges={skill.takenChallenges}
                                totalWebinars={skill.overallEvents}
                                completedWebinars={skill.takenEvents}
                                completion={skill.avgCompletion}
                                pillarGrade={skill.avgGrade}
                                perModuleAnalyticsLink={`${PLATFORM_ROUTES.analysis_per_module(skill.categoryId)}`}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </div>
    );
};
